import styled from 'styled-components';

export const SelectTemplateWrapper = styled.div`
  & > div > div > div > div:first-child {
    width: 100%;
  }
`;

export const SelectTemplateOptions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  svg {
    color: ${(props) => props.color};
    ${(props) =>
      props.isMulti === true
        ? { marginLeft: '0.5rem' }
        : { marginRight: '0.5rem' }}
  }
`;

export const ButtonDeleteFieldArea = styled.div`
  margin-top: 0rem;
  margin-left: 1rem;
`;

export const FieldValueProtocolArea = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;

export const FieldValueProtocolTotalArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
